import React from "react";
import {
  Box,
  Button,
  Grid,
  Skeleton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { Comment, ErrorOutline } from "@mui/icons-material";
import { useFormik } from "formik";
import { useDispatchWrapper } from "../../../hooks";
import { IActivityComment } from "../../../redux/activity/activity.types";
import {
  fetchActivityCommentsListAsync,
  upsertActivityCommentAysnc,
} from "../../../redux/activity/activityActions";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../redux/initialStoreState";
import { LoadState } from "../../../constants/enums";
import { CustomTextField } from "../../formsComponents";
import { formatDateWithTime } from "../../../helpers";
import { useRoles } from "../../../security/RolesProvider/RolesProvider";

interface IActivityCommentsByTaskProps {
  moduleId: string;
}

export const ActivityCommentsByTask: React.FC<IActivityCommentsByTaskProps> = (
  props
) => {
  const { moduleId } = props;
  const {
    list: comments,
    loading,
    error,
  } = useSelector((storeState: IStoreState) => storeState.acitivty.comments);

  const theme = useTheme();
  const dispatch = useDispatchWrapper();
  const{firstName, lastName} = useRoles()

  const { values, handleChange, handleSubmit, resetForm } = useFormik({
    initialValues: {
      comment: "",
    },
    onSubmit: (values) => {
      dispatch(
        upsertActivityCommentAysnc(
          {
            comment: values.comment,
            comment_type: "",
            incremental_number: null,
            status: "ACTIVE",
            type_id: moduleId,
            first_name: firstName|| "",
            insert_ts: "",
            last_name: lastName|| "",
          },
          (isSuccess) => {
            if (isSuccess) {
              resetForm();
            }
          }
        )
      );
    },
  });

  const fetchComments = async () => {
    dispatch(fetchActivityCommentsListAsync(moduleId));
  };

  React.useEffect(() => {
    fetchComments();
  }, []);

  return (
    <>
      <Stack mt={3} height={"100%"} width={"100%"}>
        <Stack
          direction={"column"}
          sx={{ overflowY: "auto" }}
          spacing={1}
          mt={3}
        >
          {loading === LoadState.InProgress && (
            <>
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
            </>
          )}
          {loading === LoadState.Failed && (
            <>
              <Box
                minHeight={100}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Box display={"flex"} justifyContent={"center"} mb={1}>
                  <ErrorOutline />
                </Box>
                <Box display={"flex"} justifyContent={"center"} width={"80%"}>
                  <Typography
                    variant="body1"
                    textAlign={"center"}
                    fontWeight={600}
                  >
                    {error}
                  </Typography>
                </Box>
              </Box>
            </>
          )}

          <Box mb={4}>
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={10}>
                  <CustomTextField
                    fullWidth
                    id="comment"
                    value={values.comment}
                    sx={{ background: "#fff" }}
                    onChange={handleChange}
                    placeholder="Type comment...."
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <Button
                    variant="contained"
                    fullWidth
                    size="small"
                    type="submit"
                    // disabled={saveLoading}
                  >
                    Send
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>

          {comments.map((item, index) => {
            return <Row key={index} comment={item} />;
          })}
        </Stack>
      </Stack>
    </>
  );
};

const Row: React.FC<{ comment: IActivityComment }> = ({ comment }) => {
  const theme = useTheme();

  const colors = {
    High: "error",
    Medium: "warning",
    Low: "success",
  };
  return (
    <Stack position={"relative"} minHeight={"80px"}>
      <Stack
        direction={"row"}
        spacing={1.5}
        sx={{
          ":before": {
            content: "''",
            height: "100%",
            width: "2px",
            position: "absolute",
            left: "18px", // <-- fixed position for vertical line
            top: 0,
            bottom: 0,
            zIndex: 0,
            backgroundColor: theme.palette.error.main,
          },
        }}
      >
        <Box
          border={"1px solid #fff"}
          sx={{ backgroundColor: "#fff" }}
          zIndex={1}
          height={"fit-content"}
        >
          <Comment color="error" fontSize="large" />
        </Box>
        <Stack width={"100%"}>
          <Stack
            direction={"row"}
            flexWrap={"wrap"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography
              variant="body1"
              fontSize={"1.1rem"}
              color={"error"}
              maxWidth={"55%"}
              textOverflow={"ellipsis"}
              overflow={"hidden"}
              whiteSpace={"nowrap"}
              fontWeight={600}
            >
              {comment.first_name + " " + comment.last_name}
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {formatDateWithTime(comment.insert_ts)}
            </Typography>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant="body1" fontWeight={500}>
              {comment.comment}
            </Typography>
          </Stack>
          {/* <Typography variant="body1" fontWeight={500}>
            Created By : <span style={{marginLeft: 2}}>{task.craeted_by_name}</span>
          </Typography> */}
        </Stack>
      </Stack>
    </Stack>
  );
};
